import lightGallery from 'lightgallery';
import Swiper from "swiper";
import lgVideo from 'lightgallery/plugins/video';

import {
    Navigation,
    Thumbs,
    EffectFade,
    FreeMode,
    Keyboard,
} from "swiper/modules";

// import Swiper and modules styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import "swiper/css/a11y";
import "swiper/css/free-mode";
import "swiper/css/thumbs";
import "swiper/css/keyboard";

// Import LightGallery CSS
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';       // Optional: for zoom plugin
import 'lightgallery/css/lg-thumbnail.css';  // Optional: for thumbnail plugin
import 'lightgallery/css/lg-video.css';      // Optional: for video plugin


class MediaGallery {
    constructor(element) {
        // Class properties.
        this.el = element;
        this.mainCarouselEl = this.el.querySelector("[data-main-carousel]");
        this.navCarouselEl = this.el.querySelector("[data-nav-carousel]");
        this.mainSwiper = null;
        this.navSwiper = null;

        //this.removeVideoFromDialog = this.removeVideoFromDialog.bind(this);

        this.init();
    }

    init() {
        this.instantiateSwipers();
        //this.handleVideoDialog();
    }

    instantiateSwipers() {
        // Instantiate the Nav carousel.
        if (this.navCarouselEl) {
            this.navSwiper = new Swiper(this.navCarouselEl, {
                loop: true,
                spaceBetween: 16,
                slidesPerView: 2.8,
                speed: 200,
                direction: "horizontal",
                //freeMode: true,
                autoHeight: true,
                watchSlidesProgress: true,
                containerMessage: `Changing the current slide of this carousel will change
                the current slide of the preceding main image carousel`,
                containerRole: `region`,
                grabCursor: true,
                //loopPreventsSliding: false,
                slideToClickedSlide: true,
                breakpoints: {
                    768: {
                         slidesPerView: 6,
                          slideToClickedSlide: true,
                    },
                },
                navigation: {
                    nextEl: this.el.querySelector(".thumbnail-button-next"),
                    prevEl: this.el.querySelector(".thumbnail-button-prev"),
                },
                modules: [Navigation, Thumbs],
            });

            this.navSwiper.on("click", function () {
             
              if (typeof this.clickedIndex !== "undefined") {
                // When loop mode is enabled, the clicked slide is duplicated.
                // Use the real index if available.
                let realIndex =
                  this.clickedSlide &&
                  this.clickedSlide.getAttribute("data-swiper-slide-index");
                // Fallback to clickedIndex if realIndex is not available.
                realIndex = realIndex !== null ? parseInt(realIndex, 10) : this.clickedIndex;
                // Use slideToLoop to calculate the proper offset in loop mode.
                this.slideToLoop(realIndex, 200);
              }
            });
        }

        // Instantiate the main carousel.
        if (this.mainCarouselEl) {
            this.mainSwiper = new Swiper(this.mainCarouselEl, {
                loop: true,
                spaceBetween: 8,
                speed: 1000,
                autoHeight: true,
                effect: "fade",
                loopPreventsSliding: false,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                fadeEffect: {
                    crossFade: true,
                },
                grabCursor: true,
                thumbs: {
                    swiper: this.navSwiper,
                },
                containerRole: `region`,
                containerRoleDescriptionMessage: `Media gallery main carousel`,
                modules: [Thumbs, EffectFade, Keyboard],
                on: {
                    init: () => {
                      // initialize LightGallery on the same element
                      const lg = lightGallery(this.mainCarouselEl, {
                        plugins: [lgVideo],
                        speed: 300,
                        selector: 'figure.media-item',
                        zoomFromOrigin: false,
                        //subHtmlSelectorRelative: true,
                        getCaptionFromTitleOrAlt: true,
                        closable: true,
                        enableDrag: true,
                        enableSwipe: true,
                        escKey: true,
                        hideBarsDelay: 2,
                        keyPress: true,
                        counter: false,
                        download: false,
                        mode: 'lg-fade',
                        //width: '75%',
                      })
                      // when LightGallery closes, jump Swiper to the last-opened slide
                      this.mainCarouselEl.addEventListener('lgBeforeClose', () => {
                        this.mainSwiper.slideTo(lg.index, 0)
                      })
                    }
                  }
            });
        }
    }

    
}

document.addEventListener("DOMContentLoaded", () => {
    const mediaCarousels = document.querySelectorAll(
        `.media:has([data-carousel])`,
    );

    mediaCarousels.forEach((element) => {
        new MediaGallery(element);
    });
});

export default MediaGallery;
